import React from "react";
import { Loader } from "../../lib/ui/components";
import { useParams } from "react-router-dom";
import _ from "lodash";
import "./product-catalogue-print.style.scss";
import {
  handleRenderImageSrc,
  primaryDetailsOrder,
  productDataMap,
  technicalInformationRows,
  unitMap,
} from "./product-catalogue-print.constant";
import headerBanner from "../../assets/images/catalogue/mth-print-header.png";
import { useProduct } from "../../lib/hooks/useProduct";
import { countries } from "../../lib/constants/countries";

export const ProductCataloguePrintMthComponent = () => {
  const { productId } = useParams<{ productId: string }>();
  const { product, isLoading, error } = useProduct(productId);

  if (isLoading) return <Loader visible />;
  if (error) return <div>Error loading product.</div>;
  if (!product) return null;

  const productName = _.startCase(
    (product.metaDataObj["machine_type"].value as string) || ""
  );
  const productModel = _.startCase(
    (product?.metaDataObj["model"]?.value as string) || ""
  );
  const productCompany = _.startCase(
    (product.metaDataObj["company"]?.value as string) || ""
  );

  const productTitle = `${productName} - ${productCompany} - ${productModel}`;
  const productNameForSpec = `${productCompany} - ${productModel}`;

  const customKeyMap = {
    product_name: productNameForSpec,
    dimensions:
      product.dimensions.length ||
      product.dimensions.width ||
      product.dimensions.height
        ? `${product.dimensions.length} * ${product.dimensions.width} * ${product.dimensions.height}`
        : "",
  };

  function getDataFromProduct(key) {
    if (key.startsWith("custom:")) {
      return customKeyMap[key.replace("custom:", "")] || "-";
    }

    if (key === "made_in") {
      return countries[product.metaDataObj[key]?.value as string] || "-";
    }

    return product.metaDataObj[key]?.value || product[key] || "-";
  }

  return (
    <div id="product-catalogue-print-wrapper" className="printable-area">
      <div className="page-container-product-catalogue-mth --prevent-font">
        <div className="page-header-print">
          <img
            src={headerBanner}
            alt="Company Banner"
            className="header-banner"
          />
        </div>
        <div className="page-footer-print">
          <div className="footer-border"></div>
        </div>
        <table className="print-layout-table">
          <thead>
            <tr>
              <td>
                <div className="header-spacer"></div>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div className="main-content">
                  <h1 id="category-title">{productTitle}</h1>
                  <div className="large-image-container">
                    {handleRenderImageSrc(product.images, 1)}
                  </div>
                  <div className="primary-details">
                    {primaryDetailsOrder.map((key) => {
                      const dataValue: keyof typeof productDataMap =
                        product.meta_data.find(
                          ({ key: metaKey }) => metaKey === key
                        )?.value ?? product[key];

                      return (
                        <span>
                          {productDataMap[key].title}: {dataValue}
                        </span>
                      );
                    })}
                    <span>location: - </span>
                  </div>
                  <div className="tech-info">
                    <div className="tech-info-data">
                      <h2 className="header force-break">
                        Technical Information:
                      </h2>
                      <table className="spec-table">
                        <thead>
                          <tr>
                            <th scope="col">Specification</th>
                            <th scope="col">Unit</th>
                            <th scope="col">Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          {technicalInformationRows.map((rawKey) => {
                            const key = rawKey.replace("custom:", "");
                            let value = getDataFromProduct(rawKey);
                            if (value ==="دارد" || value==="تدارد") value = value==="دارد"? "Yes":"No"
                            if (value === "-") return null;
                            return (
                              <tr key={key}>
                                <td>
                                  {productDataMap[key]?.title ??
                                    _.startCase(key)}
                                </td>
                                <td>{unitMap[key] ?? "-"}</td>
                                <td>{value}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                    <div className="image-column force-break">
                      {handleRenderImageSrc(product.images, 2)}
                      {handleRenderImageSrc(product.images, 3)}
                    </div>
                  </div>
                  {/* <div>
                    <h2 className="delivery-header">Delivery</h2>
                    <p>Delivery terms: EX work as is where is (UK)</p>
                    <p>
                      Delivery: Machine will be shipped in 1×20’ flat rack
                      container + 1×40’ standard container
                    </p>
                  </div> */}
                  <div>
                    <h2 className="delivery-header force-break">
                      More Photos:
                    </h2>
                    <div className="image-gallery">
                      {product.images.slice(3).map((image) => (
                        <img
                          src={image.src}
                          alt="catalogue"
                          className="catalogue-img"
                        />
                      ))}
                    </div>
                  </div>
                  <div className="farewell-message mt-auto">
                    <b>
                      We hope we have made a good proposal with this and would
                      love to hear your thoughts.
                    </b>
                    <p>Machine Technique Team</p>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td>
                <div className="footer-spacer"></div>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
};
